// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__ddQAv","addWidgetButton":"Header_addWidgetButton__3i_W8","dashboardTabs":"Header_dashboardTabs__3323x","active":"Header_active__k6xCR"};